import 'Styles/templates/page.upload-segment-details.scss';
const { Analytics } = require('@segment/analytics-node');

let segmentAnalytics = null;

const fileInput = document.getElementById('fileInput');
const fileNameText = document.getElementById('fileNameText');
const dropZone = document.getElementById('dropZone');
const uploadButton = document.getElementById('uploadButton');

// Picking writeKey from the application's installed analytics key
if (analytics) {
  analytics.ready(function() {
    segmentAnalytics = new Analytics({ writeKey: analytics.settings.writeKey });
  });
}

// https://github.com/segment-services-eng/csv2segment

const forceColums = false; // if true this will include all file columns (NOT RECOMMENDED)

const fileCols = {
  event_type: { datatype: 'String', allowNull: false, isEvent: false },
  event_name: { datatype: 'String', allowNull: true, isEvent: true },
  anonymous_id: { trait: 'anonymous_id', datatype: 'String', isAnonymous: true },
  user_id: { trait: 'user_id', datatype: 'String', isUser: true },
  stio_unique_user_id: { trait: 'stio_unique_user_id', datatype: 'String', allowNull: true },
  total_ecomm_orders: { trait: 'total_ecomm_orders', datatype: 'Number', allowNull: true },
  total_ecomm_revenue: { trait: 'total_ecomm_revenue', datatype: 'String' },
  total_ecomm_cogs: { trait: 'total_ecomm_cogs', datatype: 'String' },
  ecomm_margin_dollars: { trait: 'ecomm_margin_dollars', datatype: 'String' },
  first_name: { trait: 'first_name', datatype: 'String' },
  last_name: { trait: 'last_name', datatype: 'String' },
  email: { trait: 'email', datatype: 'String' },
  bill_to_address1: { trait: 'bill_to_address1', datatype: 'String' },
  bill_to_address2: { trait: 'bill_to_address2', datatype: 'String' },
  bill_to_city: { trait: 'bill_to_city', datatype: 'String' },
  bill_to_state: { trait: 'bill_to_state', datatype: 'String' },
  bill_to_country: { trait: 'bill_to_country', datatype: 'String' },
  bill_to_zip: { trait: 'bill_to_zip', datatype: 'String' },
  address: { trait: 'address', datatype: 'String' },
  phone: { trait: 'phone', datatype: 'String' },
  customer_tag: { trait: 'customer_tag', datatype: 'String' },
  latest_ecomm_order_date: { trait: 'latest_ecomm_order_date', datatype: 'String' },
  ecom_buyer: { trait: 'ecom_buyer', datatype: 'Boolean' },
  net_extended_msrp_total: { trait: 'net_extended_msrp_total', datatype: 'String' },
  net_revenue_total: { trait: 'net_revenue_total', datatype: 'String' },
  net_cost_total: { trait: 'net_cost_total', datatype: 'String' },
  net_margin_total: { trait: 'net_margin_total', datatype: 'String' },
  discount_total: { trait: 'discount_total', datatype: 'String' },
  sale_order_count_total: { trait: 'sale_order_count_total', datatype: 'String' },
  discount_gross_first_sale: { trait: 'discount_gross_first_sale', datatype: 'String' },
  buyer_channel_status: { trait: 'buyer_channel_status', datatype: 'String' }
};

// Disable upload button initially
function disableUploadButton() {
  uploadButton.disabled = true;
  uploadButton.classList.add('disabled');
}

// Enable upload button
function enableUploadButton() {
  uploadButton.disabled = false;
  uploadButton.classList.remove('disabled');
}

// Show error for invalid file on UI
function triggerInvalidFileError() {
  fileNameText.textContent = 'Invalid file. Please select a CSV file.';
  fileNameText.style.color = '#D93A3A'; // red
}

// Handle file selection
function handleFileChange() {
  const file = fileInput.files[0];

  if (!file) {
    fileNameText.textContent = 'Upload CSV file here';
    fileNameText.style.color = '#414042'; // dark-gray
    disableUploadButton();
    return;
  }

  if (file.type !== 'text/csv') {
    triggerInvalidFileError();
    disableUploadButton();
  } else {
    fileNameText.textContent = file.name;
    fileNameText.style.color = '#414042'; // dark-gray
    enableUploadButton();
  }
}

// Upload file and return success or error
async function uploadFile() {
  if (fileInput.files.length === 0 || fileInput.files[0].type !== 'text/csv') {
    triggerInvalidFileError();
    return;
  }

  fileNameText.textContent = 'Uploading...';
  fileNameText.style.color = '#414042'; // dark-gray

  const file = fileInput.files[0];

  try {
    processCSV(file);
    fileNameText.textContent = 'File uploaded successfully!';
    fileNameText.style.color = '#27863A'; // green
    fileInput.value = '';
    disableUploadButton();
  } catch (error) {
    fileNameText.textContent = 'Upload failed. Please try again.';
    fileNameText.style.color = '#D93A3A'; // red
  }
}

function processCSV(csvFile) {
  let columnMap = {};
  const reader = new FileReader();
  reader.onload = function (event) {
    const text = event.target.result;
    const rows = text
      .split('\n')
      .map((row) => row.trim())
      .filter((row) => row);

    if (rows.length === 0) {
      console.error('CSV file is empty.');
      return;
    }

    rows.forEach((csvRow, index) => {
      const values = csvRow
        .split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
        .map((value) => value.replace(/^"(.*)"$/, '$1').trim());

      if (index === 0) {
        columnMap = mapColumns(fileCols, values, forceColums);
      } else {
        const thisRow = setVars(columnMap, values);

        if (thisRow !== false) {
          const error = validateFields(thisRow.properties);
          if (error) {
            alert(error);
            return;
          }

          if (thisRow.isIdentity) {
            sendIdentifies(thisRow);
          }
          if (thisRow.event) {
            sendTracks(thisRow);
          }
        } else {
          console.warn(`Row ${index + 1} is invalid: Must contain UserId or AnonymousId`);
        }
      }
    });
  };

  reader.onerror = function () {
    console.error('Error reading the file.');
  };

  reader.readAsText(csvFile);
}

function sendIdentifies({ userId, anonymousId, properties }) {
  segmentAnalytics.identify({
    userId,
    anonymousId,
    traits: properties,
    integrations: {},
  });
};

function sendTracks({ event, userId, anonymousId, properties, timestamp }) {
  if (!event) return;
  
  const sanitizedProps = { ...properties };
  ['user_id', 'stio_unique_user_id', 'email', 'anonymous_id'].forEach((k) => delete sanitizedProps[k]);

  segmentAnalytics.track({
    event,
    userId,
    anonymousId,
    properties: sanitizedProps,
    timestamp,
    integrations: {},
  });
};

function mapColumns(colData, headers, includeAll = false) {
  const map = {};

  headers.forEach((key, i) => {
    if (colData[key]) {
      const def = colData[key];
      map[i] = {
        trait: def.trait || key.trim().toLowerCase().replace(' ', '_'),
        datatype: def.datatype || 'String',
        allownull: def.allowNull || false,
        context: def.context || false,
      };

      if (def.isUser) map.user_id = i;
      if (def.isAnonymous) map.anonymous_id = i;
      if (def.isGroup) map.group_id = i;
      if (def.isTimestamp) map.timestamp = i;
      if (def.isEvent) map.event = i;
      if (def.isPage) map.page = i;
      if (def.isScreen) map.screen = i;
    } else if (includeAll) {
      map[i] = {
        trait: key.trim().toLowerCase().replaceAll(' ', '_'),
        datatype: 'String',
        allownull: true,
        context: false,
      };
    }
  });

  return map;
};

function setVars(map, data) {
  const obj = {
    properties: {},
    context: {},
    userId: map.user_id ? formatData(data[map.user_id], map[map.user_id].datatype) : null,
  };

  if (map.anonymous_id) obj.anonymousId = data[map.anonymous_id] ? formatData(data[map.anonymous_id], map[map.anonymous_id].datatype) : undefined;
  if (map.group_id) obj.groupId = data[map.group_id] ? formatData(data[map.group_id], map[map.group_id].datatype) : undefined;
  if (map.timestamp) obj.timestamp = data[map.timestamp] ? formatData(data[map.timestamp], 'Date') : undefined;
  if (map.event) obj.event = data[map.event] ? formatData(data[map.event], map[map.event].datatype) : undefined;
  if (map.page) obj.pageName = data[map.page] ? formatData(data[map.page], 'String') : undefined;
  if (map.screen) obj.screenName = data[map.screen] ? formatData(data[map.screen], 'String') : undefined;

  Object.entries(map).forEach(([key, def]) => {
    if (isNaN(key)) return;

    let value = def.allowNull && (!data[key] || data[key] === '') ? null : data[key];

    if (def.trait === 'bill_to_zip' && typeof value === 'string') {
      value = value.replace(/["“”]+([^"“”]+)["“”]+/g, '$1');
    }

    if (def.trait === 'event_type' && value?.toLowerCase() === 'identity') {
      obj.isIdentity = true;
    }

    if (!isExcludeFromContextAndProperties(def.trait) && value) {
      const formatted = formatData(value, def.datatype);
      def.context ? (obj.context[def.trait] = formatted) : (obj.properties[def.trait] = formatted);
    }
  });

  return obj.userId || obj.anonymousId ? obj : false;
};

function isExcludeFromContextAndProperties(key) {
  const excludeKeys = ['event_name', 'event_type'];
  return excludeKeys.includes(key);
}

function validateFields(fields) {
  if (!fields) return 'Missing fields data.';

  if (fields.phone && !validatePhoneNumber(fields.phone)) {
    return 'Invalid phone number format.';
  }

  return null; // no errors
};

function validatePhoneNumber(phoneNumber) {
  // Example usage:
  // const phoneNumbers = [
  //   "+1 (123) 456-7890", // Valid
  //   "123-456-7890",      // Valid
  //   "(123) 456-7890",    // Valid
  //   "123.456.7890",      // Valid
  //   "1234567890",        // Valid
  //   "+44 20 1234 5678",  // Valid
  //   "+91-9876543210",    // Valid
  //   "123-456-7890 x123", // Valid
  //   "123-456-7890 ext. 123", // Valid
  //   "123-45-6789",       // Invalid
  //   "123456789",         // Invalid
  //   "123-456-7890-1234"  // Invalid
  // ];

  const phoneRegex =
    /^(?:(?:\+?\d{1,3}[-. ]?)?(?:\(?\d{1,4}\)?[-. ]?)?\d{1,4}[-. ]?\d{1,4}[-. ]?\d{1,9}(?: x\d+| ext\. \d+)?|(?:\d{3}[-. ]?\d{3}[-. ]?\d{4}))$/;
  return phoneRegex.test(phoneNumber) && phoneNumber.length >= 7;
}

function formatData(theValue, theFormat) {
  switch (theFormat.toLowerCase()) {
    case 'boolean':
      theValue = Boolean(theValue);
      break;
    case 'date':
      theValue = new Date(theValue);
      break;
    case 'iso':
      theValue = new Date(theValue).toISOString();
      break;
    case 'json':
      theValue = JSON.parse(theValue);
      break;
    case 'number':
      theValue = Number(theValue);
      break;
  }

  return theValue;
}

// Add event listeners
if (fileInput) {
  fileInput.addEventListener('change', handleFileChange);
}

if (dropZone && fileInput) {
  dropZone.addEventListener('dragover', (e) => {
    e.preventDefault();
    dropZone.classList.add('dragover');
  });

  dropZone.addEventListener('dragleave', () => dropZone.classList.remove('dragover'));

  dropZone.addEventListener('drop', (e) => {
    e.preventDefault();
    dropZone.classList.remove('dragover');

    if (e.dataTransfer.files.length > 0) {
      fileInput.files = e.dataTransfer.files;
      fileInput.dispatchEvent(new Event('change')); // Trigger change event
    }
  });
}

if (uploadButton) {
  uploadButton.addEventListener('click', (e) => {
    e.preventDefault();
    if (segmentAnalytics) {
      uploadFile();
    } else {
      alert('analytics is not ready yet, refresh your page and wait for a few seconds.');
    }
  });
}

// Initialize with upload button disabled
disableUploadButton();
